import { css, keyframes } from '@emotion/react'
import { memo } from 'react'
import { palette } from '../styles/colors'

const progressStyles = css({
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: 4,
    display: 'block',
    backgroundColor: palette.primaryLight,
    '& span': {
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        borderRadius: 7,
        transition: 'transform 0.2s linear',
        backgroundColor: palette.primary,
    },
})
const invertedColors = css({
    backgroundColor: palette.drawerDivider,
})

const leading = keyframes({
    '0%': {
        left: '-35%',
        right: '100%',
    },
    '60%': {
        left: '100%',
        right: '-90%',
    },
    '100%': {
        left: '100%',
        right: '-90%',
    },
})

const trailing = keyframes({
    '0%': {
        left: '-200%',
        right: '100%',
    },
    '60%': {
        left: '107%',
        right: '-8%',
    },
    '100%': {
        left: '107%',
        right: '-8%',
    },
})

const leadingStyles = css({
    animation: `${leading} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`,
})
const trailingStyles = css({
    animation: `${trailing} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`,
})

type ProgressProps = {
    invert?: boolean
}

const Progress = ({ invert }: ProgressProps) => (
    // <LinearProgress css={invert ? invertedColors : null} />
    <span css={[progressStyles, invert ? invertedColors : null]}>
        <span css={leadingStyles}></span>
        <span css={trailingStyles}></span>
    </span>
)

export default memo(Progress)
